import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import cn from "classnames";
import "./ScrollArea.css";

interface ScrollAreaProps extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> {
  children: React.ReactNode;
  className?: string;
  orientation?: "vertical" | "horizontal" | "both";
  viewportRef?: React.RefObject<HTMLDivElement | null>;
}

function ScrollArea({ children, className, orientation = "vertical", viewportRef, ...props }: ScrollAreaProps) {
  const showVertical = orientation === "vertical" || orientation === "both";
  const showHorizontal = orientation === "horizontal" || orientation === "both";

  return (
    <ScrollAreaPrimitive.Root
      type="scroll"
      scrollHideDelay={1000}
      className={cn("relative overflow-hidden", className)}
      {...props}>
      <ScrollAreaPrimitive.Viewport
        ref={viewportRef}
        className={cn(
          "h-full max-h-[inherit] w-full rounded-[inherit] pb-1",
          !showHorizontal && "[&>div]:block!",
        )}>
        {children}
      </ScrollAreaPrimitive.Viewport>
      {showVertical && <ScrollBar orientation="vertical" />}
      {showHorizontal && <ScrollBar orientation="horizontal" />}
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
}

interface ScrollBarProps extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Scrollbar> {
  orientation?: "vertical" | "horizontal";
  className?: string;
}

function ScrollBar({ orientation = "vertical", className, ...props }: ScrollBarProps) {
  return (
    <ScrollAreaPrimitive.Scrollbar
      orientation={orientation}
      className={cn("scroll-area-scrollbar", className)}
      {...props}>
      <ScrollAreaPrimitive.Thumb className="scroll-area-thumb" />
    </ScrollAreaPrimitive.Scrollbar>
  );
}

export { ScrollArea, ScrollBar };
